
export default class AdvisoryBoardService {
    firstRun = true
    #localAdvisors
    async getAdvisoryBoard(forceRefresh = false) {
        const localKey = 'localAdvisorsString'
        if (this.firstRun || forceRefresh) {
            localStorage.removeItem(localKey)
        }
        this.firstRun = false

        // Check local memory for our advisors
        // If they are here, return them quickly. Want to avoid long loading on profiles
        let localString = localStorage.getItem(localKey)
        if (localString != null && localString.length > 0) {
            let parsed = JSON.parse(localString)
            this.#localAdvisors = parsed
            return parsed
        }

        let remoteResponse = await this.$http.get('advisory_board')
        let advisorData = remoteResponse.data.data
        this.#localAdvisors = advisorData
        localStorage.setItem(localKey, JSON.stringify(advisorData))
        return advisorData
    }

    /**
     * Extended to provide results for pending as well
     * @param {String} uuid Uuid of the non signed in user to check for. 
     */
    async advisoryBoardFor(uuid) {
        if (this.#localAdvisors == null) {
            await this.getAdvisoryBoard()
        }

        const matches = this.#localAdvisors.filter(advisor => advisor.advisor.uuid == uuid)
        return matches.length > 0 ? matches[0] : null
    }
}